const blockFanSidedVideoAds = [
  '270',
  '138',
  '35',
  '54',
  'floor8_en_international_web',
];
const blockFanSidedVideo = ['245', '139', '55', '50'];
const blockFanSidedAds = ['233', '152', '28', '56'];

export const hasFanSidedVideo = (propertyId: string) => {
  return (
    !blockFanSidedVideo.includes(propertyId) &&
    !blockFanSidedVideoAds.includes(propertyId)
  );
};

export const hasFanSidedAds = (propertyId: string) => {
  return (
    !blockFanSidedAds.includes(propertyId) &&
    !blockFanSidedVideoAds.includes(propertyId)
  );
};
